/* eslint-disable camelcase */
import React from 'react'
import {
  Paper,
  Typography,
} from '@material-ui/core'

export function WorkflowRecipeCard(props) {
  const {
    recipe,
    onSelect,
    isSelected = false,
  } = props

  if (!recipe) return null

  return (
    <Paper
      elevation={isSelected ? 2 : 0}
      onClick={() => onSelect && onSelect(recipe)}
      style={{
        border: isSelected ? '2px solid #2563EB' : '1px solid #E5E7EB',
        borderRadius: 10,
        padding: '16px 20px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        backgroundColor: isSelected ? '#F0F7FF' : '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer',
        minHeight: 100,
        height: '100%',
      }}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.borderColor = '#93C5FD'
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.08)'
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.borderColor = '#E5E7EB'
          e.currentTarget.style.boxShadow = 'none'
        }
      }}
    >
      <Typography
        variant='h6'
        style={{
          fontWeight: 700,
          fontSize: 16,
          lineHeight: 1.3,
          color: '#111827',
          marginBottom: 6,
        }}
      >
        {recipe.title}
      </Typography>

      <Typography
        variant='body2'
        style={{
          color: '#4B5563',
          fontSize: 13,
          lineHeight: 1.45,
        }}
      >
        {recipe.description}
      </Typography>
    </Paper>
  )
}
